import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../../../common-components/Button/Button';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { If } from '../../../common-components/If/If';
import ServicesContext from '../../../contexts/ServicesContext';
import { ShopLocation } from '../../../models/ShopLocation';
import { strings } from '../../../resources/strings';
import { EnableLocationTransactionalCommunicationInput } from '../../../services/Locations/EnableLocationTransactionalCommunication/EnableLocationTransactionalCommunicationInput';
import { formatDateTime, toApiDateTime } from '../locationUi';
import { ContainerBody, ErrorList, RequiredHint, Row } from '../ModalNewLocation/styles';

interface IModalEnableTransactionalCommunicationProps {
  location: ShopLocation;
  close: () => void;
  finish: () => void;
}

const ModalEnableTransactionalCommunication: React.FC<IModalEnableTransactionalCommunicationProps> = ({
  location,
  close,
  finish
}) => {

  const { enableLocationTransactionalCommunicationService, toastService, alertService } = React.useContext(ServicesContext);

  const [sinceDate, setSinceDate] = React.useState<Date | null>(new Date());
  const [errors, setErrors] = React.useState<string[]>([]);
  const [saving, setSaving] = React.useState<boolean>(false);

  return (
    <Modal
      show={true}
      onHide={() => close()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Habilitar comunicação transacional</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '78vh' }}>
        <ContainerBody>
          <RequiredHint>
            Loja <strong>{location.name}</strong>. Informe a partir de quando a comunicação transacional fica ativa.
          </RequiredHint>
          <Row>
            <Field
              type={FieldType.DateTimePicker}
              label={'Ativa desde'}
              value={sinceDate}
              change={(value) => setSinceDate(value)}
              marginTop={'0px'}
            />
          </Row>
          <If condition={errors.length > 0}>
            <ErrorList>
              {errors.map(error => <li key={error}>{error}</li>)}
            </ErrorList>
          </If>
        </ContainerBody>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button text={strings.Cancel} click={() => close()} marginRight={'10px'} disabled={saving} />
          <Button text={'Habilitar'} click={() => confirmAndSave()} marginLeft={'10px'} disabled={saving} />
        </div>
      </Modal.Footer>
    </Modal>
  );

  function confirmAndSave() {
    if (!sinceDate) {
      setErrors(['Informe a data e hora de início da comunicação transacional.']);
      return;
    }
    setErrors([]);

    alertService.confirm(`Confirma habilitar a comunicação transacional da loja ${location.name} a partir de ${formatDateTime(sinceDate)}?`)
      .then(answer => {
        if (answer.isConfirmed) save(sinceDate);
      });
  }

  function save(date: Date) {
    const input = new EnableLocationTransactionalCommunicationInput();
    input.id = location.id;
    input.sinceDate = toApiDateTime(date)!;

    setSaving(true);
    enableLocationTransactionalCommunicationService.handle(input)
      .then(result => {
        if (result?.value?.result) {
          toastService.success('Comunicação transacional habilitada.');
          finish();
          return;
        }
        setErrors(result?.value?.errors?.length ? result.value.errors : ['Não foi possível salvar a loja.']);
      })
      .catch(error => {
        if (error?.response) {
          toastService.warning(strings.OpsSomethingWrongSendTheData);
        } else {
          alertService.warning(strings.TheServerIsNotRespondingRefreshListAndTryAgain);
        }
      })
      .finally(() => setSaving(false));
  }
}

export { ModalEnableTransactionalCommunication };
